export * from './created-by.component';
export * from './modified-by.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/audit/index.ts